import React from 'react';
import moment from 'moment';
const Excel = require('exceljs');

export const generateExcelNormal = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('Timesheet (Normal)', {
    pageSetup: { paperSize: 9, orientation: 'portrait' },
  });

  ws.pageSetup.fitToPage = true;
  ws.pageSetup.fitToWidth = 1;
  ws.pageSetup.fitToHeight = 0;
  ws.pageSetup.showGridLines = true;

  ws.columns = [
    {
      key: 'date',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'task',
      width: 13.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'description',
      width: 22.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'timeIn',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'timeOut',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'workHour',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otWorkDay',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otHolidayWork',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otHolidayNonWorking',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'remark',
      width: 9.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
  ];

  ws.properties.defaultRowHeight = 15;
  ws.pageSetup.printArea = 'A1:J57';

  ws.mergeCells('A1:B1');
  ws.mergeCells('C1:J1');

  const logo = wb.addImage({
    base64:
      'data:image/png;base64,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',
    extension: 'png',
  });
  ws.addImage(logo, 'A1:B1');

  ws.getRow(1).height = 37.5;
  ws.getCell('C1').value = 'TIMESHEET';
  ws.getCell('C1').font = {
    name: 'Arial',
    size: 24,
    bold: true,
  };
  ws.getCell('C1').alignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  };

  ws.mergeCells('B2:C2');
  ws.mergeCells('E2:J2');
  for (let i = 0; i <= 5; i++) {
    switch (i) {
      case 1:
        ws.getRow(2).getCell(i).value = 'Name:';
        break;
      case 2:
        ws.getRow(2).getCell(i).value =
          data.generalInfo.firstnameEn + ' ' + data.generalInfo.lastnameEn;
        break;
      case 4:
        ws.getRow(2).getCell(i).value = 'Emp. ID:';
        break;
      case 5:
        ws.getRow(2).getCell(i).value = data.generalInfo.empCode;
        break;
    }
  }

  ws.mergeCells('B3:C3');
  ws.mergeCells('E3:J3');

  for (let i = 0; i <= 5; i++) {
    switch (i) {
      case 1:
        ws.getRow(3).getCell(i).value = 'Role:';
        break;
      case 2:
        ws.getRow(3).getCell(i).value = data.generalInfo.projectRole;
        break;
      case 4:
        ws.getRow(3).getCell(i).value = 'Duration:';
        break;
      case 5:
        ws.getRow(3).getCell(i).value = data.generalInfo.duration;
        break;
    }
  }

  ws.mergeCells('A4:B4');
  ws.mergeCells('C4:J4');
  ws.getCell('A4').value = 'Project name:';
  ws.getCell(
    'C4',
  ).value = `${data.generalInfo.projectNo}:${data.generalInfo.projectName}`;

  for (let row = 2; row <= 4; row++) {
    for (let col = 1; col <= 5; col++) {
      if (col == 1 || (col == 4 && row != 4) || (col == 2 && row == 4)) {
        //cell Name : ,Role :, EmpId:, Duration :, Customer:
        ws.getRow(row).getCell(col).font = {
          name: 'Arial',
          size: 11,
          bold: true,
        };
      } else {
        ws.getRow(row).getCell(col).font = {
          name: 'Arial',
          size: 11,
          bold: false,
        };
      }
      ws.getRow(row).getCell(col).alignment = {
        wrapText: true,
        vertical: 'top',
      };
    }
  }

  ws.mergeCells('A5:J5');
  ws.getRow(5).height = 4.5;

  const row6 = ws.getRow(6);
  for (let col = 1; col <= 10; col++) {
    if (col < 7 || col > 9) {
      ws.mergeCells(6, col, 7, col);
    } else if (col == 7) {
      ws.mergeCells(6, col, 6, col + 2);
    }

    switch (col) {
      case 1:
        row6.getCell(col).value = 'Date';
        break;
      case 2:
        row6.getCell(col).value = 'Task';
        break;
      case 3:
        row6.getCell(col).value = 'Description';
        break;
      case 4:
        row6.getCell(col).value = 'Time In';
        break;
      case 5:
        row6.getCell(col).value = 'Time Out';
        break;
      case 6:
        row6.getCell(col).value = 'Work\n(hours)';
        break;
      case 7:
        row6.getCell(col).value = 'OT (hours)';
        break;
      case 10:
        row6.getCell(col).value = 'Remark';
        break;
    }
  }

  const row7 = ws.getRow(7);
  for (let col = 7; col <= 9; col++) {
    switch (col) {
      case 7:
        row7.getCell(col).value = 'Working\nDay';
        break;
      case 8:
        row7.getCell(col).value = 'Holiday\nWorking';
        break;
      case 9:
        row7.getCell(col).value = 'Holiday Non-\nworking';
        break;
    }
  }

  for (let row = 6; row <= 7; row++) {
    for (let col = 1; col <= 10; col++) {
      ws.getRow(row).getCell(col).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      };
      ws.getRow(row).getCell(col).font = {
        name: 'Arial',
        size: 10,
        bold: true,
      };
      ws.getRow(row).getCell(col).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF00B0F0' },
      };
    }
  }

  ws.getCell('J6').font = {
    color: { argb: 'FFFF0000' },
    name: 'Arial',
    size: 10,
    bold: true,
  };

  ws.getRow(7).height = 25.5;

  let startDataRow = 8;
  let totalHour = {
    workHour: 0,
    otWorkDay: 0,
    otHolidayWorking: 0,
    otHolidayNonWorking: 0,
  };
  data.timesheetDetail.forEach((value) => {
    const date = value.timesheetDate.split('T')[0];
    const rowDate = date.split('-');

    const rowDateFormatted = rowDate[2] + '/' + rowDate[1] + '/' + rowDate[0];

    let task = '';
    let totalLeaveHour = 0;
    let isEightHoursLeave = false;

    if (value.isHoliday) {
      task = 'Holiday';
    } else if (value.isWeekend) {
      task = 'Holiday';
    } else if (value.isFullLeave) {
      task = 'Leave';
    } else if (value.detailJson.length === 0) {
      task = '';
    } else {
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName === 'Leave') {
          totalLeaveHour += detail.leaveHour;
        } else {
          task += (detail.taskTypeName || '') + '\n';
        }
      });
    }

    isEightHoursLeave = totalLeaveHour === 8;

    let description = '';
    if (value.isWeekend) {
      description = 'Weekend';
    } else if (value.isHoliday) {
      description = value.detailJson[0].taskDescription;
    } else if (value.isFullLeave) {
      description += value.detailJson[0].taskDescription;
    } else if (isEightHoursLeave) {
      task = 'Leave';
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName === 'Leave') {
          description += (detail.taskDescription || '') + '\n';
        }
      });
    } else if (value.workMinutes !== 0) {
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName !== 'Leave') {
          description += (detail.taskDescription || '') + '\n';
        }
      });
    }

    let workTaskList = value.detailJson.filter(
      (x) => x.taskTypeName !== 'Holiday' && x.taskTypeName !== 'Leave',
    );

    workTaskList.sort(function (a, b) {
      var keyA = new Date(a.startTime),
        keyB = new Date(b.startTime);
      if (keyA > keyB) return 1;
      if (keyA < keyB) return -1;
      return 0;
    });

    let startText = '';
    let endText = '';
    let start = [];
    let end = [];
    if (value.totalMinutes !== 0) {
      for (let i = 0; i < workTaskList.length; i++) {
        workTaskList[i].startTime = workTaskList[i].startTime
          ? new Date(workTaskList[i].startTime)
          : '';
        workTaskList[i].endTime = workTaskList[i].endTime
          ? new Date(workTaskList[i].endTime)
          : '';
        start.push(workTaskList[i].startTime);
        end.push(workTaskList[i].endTime);
      }
      start.forEach((value) => {
        startText += value
          ? value.toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
              hour12: false,
            }) + '\n'
          : '\n';
      });
      startText.trim();

      end.forEach((value) => {
        endText += value
          ? value.toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
              hour12: false,
            }) + '\n'
          : '\n';
      });
      endText.trim();
    }

    ws.insertRow(startDataRow, {
      date: rowDateFormatted,
      task: task.trim(),
      description: description.trim(),
      timeIn: startText.trim(),
      timeOut: endText.trim(),
      workHour: value.totalMinutes === 0 ? '' : value.totalMinutes / 60,
    });

    totalHour.workHour += value.totalMinutes / 60;

    startDataRow++;
  });

  ws.getRows(8, 38).forEach((row) => {
    if (
      row.getCell(2).value === 'Holiday' ||
      row.getCell(2).value === 'Leave'
    ) {
      for (let i = 1; i <= 10; i++) {
        row.getCell(i).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'B8CCE4' },
        };
      }
    }

    for (let col = 1; col <= 10; col++) {
      if (col == 1 || col == 2) {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'center',
        };
      } else if (col == 3) {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'left',
        };
      } else {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'right',
        };
      }

      if (6 <= col <= 9) {
        row.getCell(col).numFmt = '0.00';
      }
    }
  });

  ws.getRows(1, 38).forEach((row) => {
    for (let i = 1; i <= 10; i++) {
      row.getCell(i).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  });

  ws.mergeCells('A43:C43');
  ws.mergeCells('A44:C44');
  ws.mergeCells('A45:C45');
  ws.mergeCells('A46:C46');

  ws.mergeCells('A52:B52');
  ws.mergeCells('C52:D52');
  ws.mergeCells('F52:G52');

  ws.mergeCells('C53:D53');
  ws.mergeCells('F53:G53');

  ws.mergeCells('A55:B55');
  ws.mergeCells('C55:D55');
  ws.mergeCells('F55:G55');

  ws.mergeCells('C56:D56');
  ws.mergeCells('F56:G56');

  ws.getRows(39, 56).forEach((row) => {
    for (let i = 1; i <= 10; i++) {
      row.getCell(i).border = {
        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      };
    }
  });

  const cellWithBorder = (cell, value, boldStyle, horizontal) => {
    ws.getCell(cell).value = value;
    ws.getCell(cell).font = {
      name: 'Arial',
      size: 10,
      bold: boldStyle === 'bold',
    };
    ws.getCell(cell).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    ws.getCell(cell).alignment = { horizontal: horizontal };
  };

  ws.getRow(39, 41).height = 14.25;

  cellWithBorder('C39', 'Total work hour/month', 'bold', 'left');
  cellWithBorder('F39', totalHour.workHour, 'normal', 'right');
  cellWithBorder('G39', totalHour.otWorkDay, 'normal', 'right');
  cellWithBorder('H39', totalHour.otHolidayWorking, 'normal', 'right');
  cellWithBorder('I39', totalHour.otHolidayNonWorking, 'normal', 'right');
  cellWithBorder('J39', '', 'normal', 'right');

  ws.getRows(39, 41).forEach((row) => {
    for (let col = 6; col <= 9; col++) {
      row.getCell(col).numFmt = '0.00';
    }
  });

  cellWithBorder('C40', 'Total OT hour/month', 'bold', 'left');
  cellWithBorder(
    'F40',
    totalHour.otWorkDay +
      totalHour.otHolidayWorking +
      totalHour.otHolidayNonWorking,
    'normal',
    'right',
  );

  cellWithBorder('C41', 'Total work day/month', 'bold', 'left');
  cellWithBorder('F41', totalHour.workHour / 8, 'normal', 'right');

  cellWithBorder('A43', 'Sick Leave', 'bold', 'center');
  cellWithBorder('D43', data.summary.sickLeave, 'normal', 'center');

  cellWithBorder('A44', 'Annual Leave', 'bold', 'center');
  cellWithBorder('D44', data.summary.annualLeave, 'normal', 'center');

  cellWithBorder('A45', 'Private Leave', 'bold', 'center');
  cellWithBorder('D45', data.summary.personalLeave, 'normal', 'center');

  cellWithBorder('A46', 'Public Holiday', 'bold', 'center');
  cellWithBorder('D46', data.summary.publicHoliday, 'normal', 'center');

  ws.getRow(47).height = 8.25;

  ws.getCell('A48').value =
    'OT Working Day = work on working day ( Mon-Fri)  after normal working hour ( 9:00-18:00 ), after 30 minute break';

  ws.getCell('A49').value =
    'OT Holiday Working Hour = work on weekend and holiday in normal working hour ( 9:00-18:00 )';

  ws.getCell('A50').value =
    'OT Holiday Non Working Hour = work on weekend and holiday after normal working hour ( 9:00-18:00 ) after 30 minute break';

  ws.getRows(48, 50).forEach((row) => {
    row.font = { name: 'Arial', size: 9 };
    row.alignment = { wrapText: false };
  });

  ws.getRow(51).height = 7.5;

  ws.getCell('A52').value = 'Prepared by';
  ws.getCell('A52').alignment = { horizontal: 'center' };
  ws.getCell('A52').font = { name: 'Arial', size: 11, bold: true };

  ws.getCell('C52').border = {
    bottom: { style: 'thin' },
  };
  ws.getCell('C52').font = { name: 'Arial', size: 10 };

  ws.getCell('F52').border = {
    bottom: { style: 'thin' },
  };
  ws.getCell('F52').font = { name: 'Arial', size: 10 };

  ws.getCell('C53').value = { formula: 'B2' };
  ws.getCell('C53').alignment = { horizontal: 'center' };

  ws.getCell('F53').value = 'Date';
  ws.getCell('F53').alignment = { horizontal: 'center' };

  ws.getCell('A55').value = 'Approved by';
  ws.getCell('A55').alignment = { horizontal: 'center' };
  ws.getCell('A55').font = { name: 'Arial', size: 11, bold: true };

  ws.getCell('C55').border = {
    bottom: { style: 'thin' },
  };

  ws.getCell('F55').border = {
    bottom: { style: 'thin' },
  };

  ws.getCell('C56').value = '(PM)';
  ws.getCell('C56').alignment = { horizontal: 'center' };

  ws.getCell('F56').value = 'Date';
  ws.getCell('F56').alignment = { horizontal: 'center' };

  let projectNo;
  state.projectOptions.forEach((project) => {
    if (project.projectId === state.selectedProject) {
      projectNo = project.projectNo;
    }
  });

  ws.getColumn(7).hidden = true;
  ws.getColumn(8).hidden = true;
  ws.getColumn(9).hidden = true;
  const filename = `Timesheet_Normal_${state.year}_${state.month}_${projectNo}`;
  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};

export const generateExcelSpecial = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('Timesheet (Special)', {
    pageSetup: { paperSize: 9, orientation: 'portrait' },
  });

  ws.pageSetup.fitToPage = true;
  ws.pageSetup.fitToWidth = 1;
  ws.pageSetup.fitToHeight = 0;
  ws.pageSetup.showGridLines = true;

  ws.columns = [
    {
      key: 'date',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'task',
      width: 13.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'description',
      width: 22.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'timeIn',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'timeOut',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'workHour',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otWorkDay',
      width: 10.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otHolidayWorking',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'otHolidayNonWorking',
      width: 12.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
    {
      key: 'remark',
      width: 9.71,
      style: {
        font: {
          name: 'Arial',
          size: 10,
        },
      },
    },
  ];

  ws.properties.defaultRowHeight = 15;
  ws.pageSetup.printArea = 'A1:J57';

  ws.mergeCells('A1:B1');
  ws.mergeCells('C1:J1');

  const logo = wb.addImage({
    base64:
      'data:image/png;base64,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',
    extension: 'png',
  });
  ws.addImage(logo, 'A1:B1');

  ws.getRow(1).height = 37.5;
  ws.getCell('C1').value = 'TIMESHEET';
  ws.getCell('C1').font = {
    name: 'Arial',
    size: 24,
    bold: true,
  };
  ws.getCell('C1').alignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  };

  ws.mergeCells('B2:C2');
  ws.mergeCells('E2:J2');
  for (let i = 0; i <= 5; i++) {
    switch (i) {
      case 1:
        ws.getRow(2).getCell(i).value = 'Name:';
        break;
      case 2:
        ws.getRow(2).getCell(i).value =
          data.generalInfo.firstnameEn + ' ' + data.generalInfo.lastnameEn;
        break;
      case 4:
        ws.getRow(2).getCell(i).value = 'Emp. ID:';
        break;
      case 5:
        ws.getRow(2).getCell(i).value = data.generalInfo.empCode;
        break;
    }
  }

  ws.mergeCells('B3:C3');
  ws.mergeCells('E3:J3');

  for (let i = 0; i <= 5; i++) {
    switch (i) {
      case 1:
        ws.getRow(3).getCell(i).value = 'Role:';
        break;
      case 2:
        ws.getRow(3).getCell(i).value = data.generalInfo.projectRole;
        break;
      case 4:
        ws.getRow(3).getCell(i).value = 'Duration:';
        break;
      case 5:
        ws.getRow(3).getCell(i).value = data.generalInfo.duration;
        break;
    }
  }

  ws.mergeCells('A4:B4');
  ws.mergeCells('C4:J4');
  ws.getCell('A4').value = 'Project name:';
  ws.getCell(
    'C4',
  ).value = `${data.generalInfo.projectNo}:${data.generalInfo.projectName}`;

  for (let row = 2; row <= 4; row++) {
    for (let col = 1; col <= 5; col++) {
      if (col == 1 || (col == 4 && row != 4) || (col == 2 && row == 4)) {
        //cell Name : ,Role :, EmpId:, Duration :, Customer:
        ws.getRow(row).getCell(col).font = {
          name: 'Arial',
          size: 11,
          bold: true,
        };
      } else {
        ws.getRow(row).getCell(col).font = {
          name: 'Arial',
          size: 11,
          bold: false,
        };
      }
      ws.getRow(row).getCell(col).alignment = {
        wrapText: true,
        vertical: 'top',
      };
    }
  }

  ws.mergeCells('A5:J5');
  ws.getRow(5).height = 4.5;

  const row6 = ws.getRow(6);
  for (let col = 1; col <= 10; col++) {
    if (col < 7 || col > 9) {
      ws.mergeCells(6, col, 7, col);
    } else if (col == 7) {
      ws.mergeCells(6, col, 6, col + 2);
    }

    switch (col) {
      case 1:
        row6.getCell(col).value = 'Date';
        break;
      case 2:
        row6.getCell(col).value = 'Task';
        break;
      case 3:
        row6.getCell(col).value = 'Description';
        break;
      case 4:
        row6.getCell(col).value = 'Time In';
        break;
      case 5:
        row6.getCell(col).value = 'Time Out';
        break;
      case 6:
        row6.getCell(col).value = 'Work\n(hours)';
        break;
      case 7:
        row6.getCell(col).value = 'OT (hours)';
        break;
      case 10:
        row6.getCell(col).value = 'Remark';
        break;
    }
  }

  const row7 = ws.getRow(7);
  for (let col = 7; col <= 9; col++) {
    switch (col) {
      case 7:
        row7.getCell(col).value = 'Working\nDay';
        break;
      case 8:
        row7.getCell(col).value = 'Holiday\nWorking';
        break;
      case 9:
        row7.getCell(col).value = 'Holiday Non-\nworking';
        break;
    }
  }

  for (let row = 6; row <= 7; row++) {
    for (let col = 1; col <= 10; col++) {
      ws.getRow(row).getCell(col).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      };
      ws.getRow(row).getCell(col).font = {
        name: 'Arial',
        size: 10,
        bold: true,
      };
      ws.getRow(row).getCell(col).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF00B0F0' },
      };
    }
  }

  ws.getCell('J6').font = {
    color: { argb: 'FFFF0000' },
    name: 'Arial',
    size: 10,
    bold: true,
  };

  ws.getRow(7).height = 25.5;

  let startDataRow = 8;
  let totalHour = {
    workHour: 0,
    otWorkDay: 0,
    otHolidayWorking: 0,
    otHolidayNonWorking: 0,
  };
  data.timesheetDetail.forEach((value) => {
    const date = value.timesheetDate.split('T')[0];
    const rowDate = date.split('-');

    const rowDateFormatted = rowDate[2] + '/' + rowDate[1] + '/' + rowDate[0];

    let task = '';
    let totalLeaveHour = 0;
    let isEightHoursLeave = false;

    if (value.isHoliday) {
      task = 'Holiday';
    } else if (value.isWeekend) {
      task = 'Holiday';
    } else if (value.isFullLeave) {
      task = 'Leave';
    } else if (value.detailJson.length === 0) {
      task = '';
    } else {
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName === 'Leave') {
          totalLeaveHour += detail.leaveHour;
        } else {
          task += (detail.taskTypeName || '') + '\n';
        }
      });
    }

    isEightHoursLeave = totalLeaveHour === 8;

    let description = '';
    if (value.isWeekend) {
      description = 'Weekend';
    } else if (value.isHoliday) {
      description = value.detailJson[0].taskDescription;
    } else if (value.isFullLeave) {
      description += value.detailJson[0].taskDescription;
    } else if (isEightHoursLeave) {
      task = 'Leave';
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName === 'Leave') {
          description += (detail.taskDescription || '') + '\n';
        }
      });
    } else if (value.workMinutes !== 0) {
      value.detailJson.forEach((detail) => {
        if (detail.taskTypeName !== 'Leave') {
          description += (detail.taskDescription || '') + '\n';
        }
      });
    }

    let workTaskList = value.detailJson.filter(
      (x) => x.taskTypeName !== 'Holiday' && x.taskTypeName !== 'Leave',
    );

    workTaskList.sort(function (a, b) {
      var keyA = new Date(a.startTime),
        keyB = new Date(b.startTime);
      if (keyA > keyB) return 1;
      if (keyA < keyB) return -1;
      return 0;
    });

    let startText = '';
    let endText = '';
    let start = [];
    let end = [];
    if (value.totalMinutes !== 0) {
      for (let i = 0; i < workTaskList.length; i++) {
        workTaskList[i].startTime = workTaskList[i].startTime
          ? new Date(workTaskList[i].startTime)
          : '';
        workTaskList[i].endTime = workTaskList[i].endTime
          ? new Date(workTaskList[i].endTime)
          : '';
        start.push(workTaskList[i].startTime);
        end.push(workTaskList[i].endTime);
      }
      start.forEach((value) => {
        startText += value
          ? value.toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
              hour12: false,
            }) + '\n'
          : '\n';
      });
      startText.trim();

      end.forEach((value) => {
        endText += value
          ? value.toLocaleTimeString([], {
              hour: 'numeric',
              minute: '2-digit',
              hour12: false,
            }) + '\n'
          : '\n';
      });
      endText.trim();
    }
    ws.insertRow(startDataRow, {
      date: rowDateFormatted,
      task: task.trim(),
      description: description.trim(),
      timeIn: startText.trim(),
      timeOut: endText.trim(),
      workHour: '',
      otWorkDay:
        value.otWorkingMinutes === 0 ? '' : value.otWorkingMinutes / 60,
      otHolidayWorking:
        value.otHolidayWorkingMinutes === 0
          ? ''
          : value.otHolidayWorkingMinutes / 60,
      otHolidayNonWorking:
        value.otHolidayNonWorkingMinutes === 0
          ? ''
          : value.otHolidayNonWorkingMinutes / 60,
    });

    totalHour.workHour += 0;
    totalHour.otWorkDay += value.otWorkingMinutes / 60;
    totalHour.otHolidayWorking += value.otHolidayWorkingMinutes / 60;
    totalHour.otHolidayNonWorking += value.otHolidayNonWorkingMinutes / 60;

    startDataRow++;
  });

  ws.getRows(8, 38).forEach((row) => {
    if (
      row.getCell(2).value === 'Holiday' ||
      row.getCell(2).value === 'Leave'
    ) {
      for (let i = 1; i <= 10; i++) {
        row.getCell(i).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'B8CCE4' },
        };
      }
    }

    for (let col = 1; col <= 10; col++) {
      if (col == 1 || col == 2) {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'center',
        };
      } else if (col == 3) {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'left',
        };
      } else {
        row.getCell(col).alignment = {
          wrapText: true,
          vertical: 'top',
          horizontal: 'right',
        };
      }

      if (6 <= col <= 9) {
        row.getCell(col).numFmt = '0.00';
      }
    }
  });

  ws.getRows(1, 38).forEach((row) => {
    for (let i = 1; i <= 10; i++) {
      row.getCell(i).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  });

  ws.mergeCells('A43:C43');
  ws.mergeCells('A44:C44');
  ws.mergeCells('A45:C45');
  ws.mergeCells('A46:C46');

  ws.mergeCells('A52:B52');
  ws.mergeCells('C52:D52');
  ws.mergeCells('F52:G52');

  ws.mergeCells('C53:D53');
  ws.mergeCells('F53:G53');

  ws.mergeCells('A55:B55');
  ws.mergeCells('C55:D55');
  ws.mergeCells('F55:G55');

  ws.mergeCells('C56:D56');
  ws.mergeCells('F56:G56');

  ws.getRows(39, 56).forEach((row) => {
    for (let i = 1; i <= 10; i++) {
      row.getCell(i).border = {
        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      };
    }
  });

  const cellWithBorder = (cell, value, boldStyle, horizontal) => {
    ws.getCell(cell).value = value;
    ws.getCell(cell).font = {
      name: 'Arial',
      size: 10,
      bold: boldStyle === 'bold',
    };
    ws.getCell(cell).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    ws.getCell(cell).alignment = { horizontal: horizontal };
  };

  ws.getRow(39, 41).height = 14.25;

  cellWithBorder('C39', 'Total work hour/month', 'bold', 'left');
  cellWithBorder('F39', totalHour.workHour, 'normal', 'right');
  cellWithBorder('G39', totalHour.otWorkDay, 'normal', 'right');
  cellWithBorder('H39', totalHour.otHolidayWorking, 'normal', 'right');
  cellWithBorder('I39', totalHour.otHolidayNonWorking, 'normal', 'right');
  cellWithBorder('J39', '', 'normal', 'right');

  ws.getRows(39, 41).forEach((row) => {
    for (let col = 6; col <= 9; col++) {
      row.getCell(col).numFmt = '0.00';
    }
  });

  cellWithBorder('C40', 'Total OT hour/month', 'bold', 'left');
  cellWithBorder(
    'F40',
    totalHour.otWorkDay +
      totalHour.otHolidayWorking +
      totalHour.otHolidayNonWorking,
    'normal',
    'right',
  );

  cellWithBorder('C41', 'Total work day/month', 'bold', 'left');
  cellWithBorder('F41', totalHour.workHour / 8, 'normal', 'right');

  cellWithBorder('A43', 'Sick Leave', 'bold', 'center');
  cellWithBorder('D43', data.summary.sickLeave, 'normal', 'center');

  cellWithBorder('A44', 'Annual Leave', 'bold', 'center');
  cellWithBorder('D44', data.summary.annualLeave, 'normal', 'center');

  cellWithBorder('A45', 'Private Leave', 'bold', 'center');
  cellWithBorder('D45', data.summary.personalLeave, 'normal', 'center');

  cellWithBorder('A46', 'Public Holiday', 'bold', 'center');
  cellWithBorder('D46', data.summary.publicHoliday, 'normal', 'center');

  ws.getRow(47).height = 8.25;

  ws.getCell('A48').value =
    'OT Working Day = work on working day ( Mon-Fri)  after normal working hour ( 9:00-18:00 ), after 30 minute break';

  ws.getCell('A49').value =
    'OT Holiday Working Hour = work on weekend and holiday in normal working hour ( 9:00-18:00 )';

  ws.getCell('A50').value =
    'OT Holiday Non Working Hour = work on weekend and holiday after normal working hour ( 9:00-18:00 ) after 30 minute break';

  ws.getRows(48, 50).forEach((row) => {
    row.font = { name: 'Arial', size: 9 };
    row.alignment = { wrapText: false };
  });

  ws.getRow(51).height = 7.5;

  ws.getCell('A52').value = 'Prepared by';
  ws.getCell('A52').alignment = { horizontal: 'center' };
  ws.getCell('A52').font = { name: 'Arial', size: 11, bold: true };

  ws.getCell('C52').border = {
    bottom: { style: 'thin' },
  };
  ws.getCell('C52').font = { name: 'Arial', size: 10 };

  ws.getCell('F52').border = {
    bottom: { style: 'thin' },
  };
  ws.getCell('F52').font = { name: 'Arial', size: 10 };

  ws.getCell('C53').value = { formula: 'B2' };
  ws.getCell('C53').alignment = { horizontal: 'center' };

  ws.getCell('F53').value = 'Date';
  ws.getCell('F53').alignment = { horizontal: 'center' };

  ws.getCell('A55').value = 'Approved by';
  ws.getCell('A55').alignment = { horizontal: 'center' };
  ws.getCell('A55').font = { name: 'Arial', size: 11, bold: true };

  ws.getCell('C55').border = {
    bottom: { style: 'thin' },
  };

  ws.getCell('F55').border = {
    bottom: { style: 'thin' },
  };

  ws.getCell('C56').value = '(PM)';
  ws.getCell('C56').alignment = { horizontal: 'center' };

  ws.getCell('F56').value = 'Date';
  ws.getCell('F56').alignment = { horizontal: 'center' };

  let projectNo;
  state.projectOptions.forEach((project) => {
    if (project.projectId === state.selectedProject) {
      projectNo = project.projectNo;
    }
  });

  const filename = `Timesheet_Special_${state.year}_${state.month}_${projectNo}`;
  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};

export const generateExcelSummary = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('My Sheet', {
    views: [{ state: 'frozen', ySplit: 3 }],
  });

  ws.columns = [
    { width: 9.71 },
    { key: 'empCode', width: 12.71 },
    { key: 'userName', width: 36.71 },
    { key: 'levelName', width: 36.71 },
    { key: 'project', width: 10.71 },
    { key: 'projectName', width: 60.71 },
    { key: 'jan', width: 9.71 },
    { key: 'feb', width: 9.71 },
    { key: 'mar', width: 9.71 },
    { key: 'apr', width: 9.71 },
    { key: 'may', width: 9.71 },
    { key: 'jun', width: 9.71 },
    { key: 'jul', width: 9.71 },
    { key: 'aug', width: 9.71 },
    { key: 'sep', width: 9.71 },
    { key: 'oct', width: 9.71 },
    { key: 'nov', width: 9.71 },
    { key: 'dec', width: 9.71 },
  ];

  ws.mergeCells('G2:R2');
  ws.getCell('G2').value = 'Effort (MD)';
  ws.getCell('G2').font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 9,
    bold: true,
  };
  ws.getCell('G2').alignment = { vertical: 'middle', horizontal: 'center' };
  ws.getCell('G2').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF00B050' },
  };
  ws.properties.defaultRowHeight = 15;

  ws.addRow({
    empCode: 'รหัสพนักงาน',
    userName: 'Name-Surname',
    levelName: 'Level',
    project: 'Project',
    projectName: 'Project Name',
    jan: 'Jan-' + state.year,
    feb: 'Feb-' + state.year,
    mar: 'Mar-' + state.year,
    apr: 'Apr-' + state.year,
    may: 'May-' + state.year,
    jun: 'Jun-' + state.year,
    jul: 'Jul-' + state.year,
    aug: 'Aug-' + state.year,
    sep: 'Sep-' + state.year,
    oct: 'Oct-' + state.year,
    nov: 'Nov-' + state.year,
    dec: 'Dec-' + state.year,
  });

  const row3 = ws.getRow(3);
  row3.height = 48;
  row3.font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 9,
    bold: true,
  };
  row3.alignment = { vertical: 'middle', horizontal: 'center' };
  for (let i = 2; i <= 18; i++) {
    row3.getCell(i).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B050' },
    };
  }

  data.users = data.users.sort(function (a, b) {
    var keyA = a.id,
      keyB = b.id;
    if (keyA > keyB) return 1;
    if (keyA < keyB) return -1;
    return 0;
  });

  data.users.forEach((user) => {
    user.projectSummary.forEach((project) => {
      if (project.projectNo === 'Leave') {
        let leaveJson = {
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          oct: 0,
          nov: 0,
          dec: 0,
        };
        project.detailJson.forEach((detail) => {
          switch (detail.month) {
            case 1:
              leaveJson.jan = detail.leaveHour / 8;
              break;
            case 2:
              leaveJson.feb = detail.leaveHour / 8;
              break;
            case 3:
              leaveJson.mar = detail.leaveHour / 8;
              break;
            case 4:
              leaveJson.apr = detail.leaveHour / 8;
              break;
            case 5:
              leaveJson.may = detail.leaveHour / 8;
              break;
            case 6:
              leaveJson.jun = detail.leaveHour / 8;
              break;
            case 7:
              leaveJson.jul = detail.leaveHour / 8;
              break;
            case 8:
              leaveJson.aug = detail.leaveHour / 8;
              break;
            case 9:
              leaveJson.sep = detail.leaveHour / 8;
              break;
            case 10:
              leaveJson.oct = detail.leaveHour / 8;
              break;
            case 11:
              leaveJson.nov = detail.leaveHour / 8;
              break;
            case 12:
              leaveJson.dec = detail.leaveHour / 8;
              break;
            default:
              break;
          }
        });
        ws.addRow({
          empCode: user.empCode,
          userName: user.firstnameEn + ' ' + user.lastnameEn,
          levelName: user.levelName,
          ...leaveJson,
        });

        ws.mergeCells(ws.rowCount, 5, ws.rowCount, 6);
        ws.lastRow.getCell(5).value = 'Leave';
      } else {
        let workJson = {
          jan: 0,
          feb: 0,
          mar: 0,
          apr: 0,
          may: 0,
          jun: 0,
          jul: 0,
          aug: 0,
          sep: 0,
          oct: 0,
          nov: 0,
          dec: 0,
        };
        project.detailJson.forEach((detail) => {
          switch (detail.month) {
            case 1:
              workJson.jan = detail.totalMinutes / 60 / 8;
              break;
            case 2:
              workJson.feb = detail.totalMinutes / 60 / 8;
              break;
            case 3:
              workJson.mar = detail.totalMinutes / 60 / 8;
              break;
            case 4:
              workJson.apr = detail.totalMinutes / 60 / 8;
              break;
            case 5:
              workJson.may = detail.totalMinutes / 60 / 8;
              break;
            case 6:
              workJson.jun = detail.totalMinutes / 60 / 8;
              break;
            case 7:
              workJson.jul = detail.totalMinutes / 60 / 8;
              break;
            case 8:
              workJson.aug = detail.totalMinutes / 60 / 8;
              break;
            case 9:
              workJson.sep = detail.totalMinutes / 60 / 8;
              break;
            case 10:
              workJson.oct = detail.totalMinutes / 60 / 8;
              break;
            case 11:
              workJson.nov = detail.totalMinutes / 60 / 8;
              break;
            case 12:
              workJson.dec = detail.totalMinutes / 60 / 8;
              break;
            default:
              break;
          }
        });

        ws.addRow({
          empCode: user.empCode,
          userName: user.firstnameEn + ' ' + user.lastnameEn,
          levelName: user.levelName,
          project: project.projectNo,
          projectName: project.projectName,
          ...workJson,
        });
      }
    });
  });

  const totalHours = {
    jan: { formula: `=SUM(G4:G${ws.rowCount})` },
    feb: { formula: `=SUM(H4:H${ws.rowCount})` },
    mar: { formula: `=SUM(I4:I${ws.rowCount})` },
    apr: { formula: `=SUM(J4:J${ws.rowCount})` },
    may: { formula: `=SUM(K4:K${ws.rowCount})` },
    jun: { formula: `=SUM(L4:L${ws.rowCount})` },
    jul: { formula: `=SUM(M4:M${ws.rowCount})` },
    aug: { formula: `=SUM(N4:N${ws.rowCount})` },
    sep: { formula: `=SUM(O4:O${ws.rowCount})` },
    oct: { formula: `=SUM(P4:P${ws.rowCount})` },
    nov: { formula: `=SUM(Q4:Q${ws.rowCount})` },
    dec: { formula: `=SUM(R4:R${ws.rowCount})` },
  };

  ws.addRow({ ...totalHours });
  ws.mergeCells(ws.rowCount, 2, ws.rowCount, 5);
  ws.lastRow.getCell(2).value = 'summary';

  ws.getCell('F2').border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  for (let i = 3; i <= ws.rowCount; i++) {
    for (let j = 2; j <= 18; j++) {
      ws.getRow(i).getCell(j).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  }

  for (let i = 4; i <= ws.rowCount; i++) {
    ws.getRow(i).getCell(2).alignment = { horizontal: 'center' };
    for (let j = 3; j <= 5; j++) {
      if (i !== ws.rowCount) {
        ws.getRow(i).getCell(j).alignment = {
          horizontal: 'left',
          wrapText: true,
        };
      }
    }
    for (let k = 7; k <= 18; k++) {
      ws.getRow(i).getCell(k).alignment = { horizontal: 'right' };
      ws.getRow(i).getCell(k).numFmt = '0.00';
    }
  }

  const filename = `Summary_Timesheet_${state.year}.xlsx`;

  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};

export const generateExcelSummaryOt = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('My Sheet', {
    views: [{ state: 'frozen', ySplit: 4 }],
  });

  const month = [
    'Jan-' + state.year,
    'Feb-' + state.year,
    'Mar-' + state.year,
    'Apr-' + state.year,
    'May-' + state.year,
    'Jun-' + state.year,
    'Jul-' + state.year,
    'Aug-' + state.year,
    'Sep-' + state.year,
    'Oct-' + state.year,
    'Nov-' + state.year,
    'Dec-' + state.year,
  ];

  ws.columns = [
    { width: 9.71 },
    { key: 'empCode', width: 12.71 },
    { key: 'userName', width: 36.71 },
    { key: 'departmentName', width: 36.71 },
    { key: 'project', width: 10.71 },
    { key: 'projectName', width: 60.71 },

    { key: 'janOtWorkDay', width: 10.71 },
    { key: 'janOtHolidayWork', width: 12.71 },
    { key: 'janOtHolidayNonWorking', width: 12.71 },

    { key: 'febOtWorkDay', width: 10.71 },
    { key: 'febOtHolidayWork', width: 12.71 },
    { key: 'febOtHolidayNonWorking', width: 12.71 },

    { key: 'marOtWorkDay', width: 10.71 },
    { key: 'marOtHolidayWork', width: 12.71 },
    { key: 'marOtHolidayNonWorking', width: 12.71 },

    { key: 'aprOtWorkDay', width: 10.71 },
    { key: 'aprOtHolidayWork', width: 12.71 },
    { key: 'aprOtHolidayNonWorking', width: 12.71 },

    { key: 'mayOtWorkDay', width: 10.71 },
    { key: 'mayOtHolidayWork', width: 12.71 },
    { key: 'mayOtHolidayNonWorking', width: 12.71 },

    { key: 'junOtWorkDay', width: 10.71 },
    { key: 'junOtHolidayWork', width: 12.71 },
    { key: 'junOtHolidayNonWorking', width: 12.71 },

    { key: 'julOtWorkDay', width: 10.71 },
    { key: 'julOtHolidayWork', width: 12.71 },
    { key: 'julOtHolidayNonWorking', width: 12.71 },

    { key: 'augOtWorkDay', width: 10.71 },
    { key: 'augOtHolidayWork', width: 12.71 },
    { key: 'augOtHolidayNonWorking', width: 12.71 },

    { key: 'sepOtWorkDay', width: 10.71 },
    { key: 'sepOtHolidayWork', width: 12.71 },
    { key: 'sepOtHolidayNonWorking', width: 12.71 },

    { key: 'octOtWorkDay', width: 10.71 },
    { key: 'octOtHolidayWork', width: 12.71 },
    { key: 'octOtHolidayNonWorking', width: 12.71 },

    { key: 'novOtWorkDay', width: 10.71 },
    { key: 'novOtHolidayWork', width: 12.71 },
    { key: 'novOtHolidayNonWorking', width: 12.71 },

    { key: 'decOtWorkDay', width: 10.71 },
    { key: 'decOtHolidayWork', width: 12.71 },
    { key: 'decOtHolidayNonWorking', width: 12.71 },
  ];

  ws.mergeCells('G2:AP2');
  ws.getCell('G2').value = 'Effort (MD)';
  ws.getCell('G2').font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 9,
    bold: true,
  };
  ws.getCell('G2').alignment = { vertical: 'middle', horizontal: 'center' };
  ws.getCell('G2').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF00B050' },
  };
  ws.properties.defaultRowHeight = 15;

  ws.addRow({
    empCode: 'รหัสพนักงาน',
    userName: 'Name-Surname',
    departmentName: 'Department',
    project: 'Project',
    projectName: 'Project Name',
  });

  for (let col = 7; col < 43; col += 3) {
    ws.mergeCells(3, col, 3, col + 2);
    const cell = ws.getRow(3).getCell(col);
    cell.value = month[(col - 7) / 3];
    cell.font = {
      color: { argb: 'FFFFFFFF' },
      name: 'Arial',
      size: 9,
      bold: true,
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B050' },
    };
  }

  ws.getRow(3).height = 17.5;

  ws.addRow({
    janOtWorkDay: 'Working\nDay',
    janOtHolidayWork: 'Holiday\nWorking',
    janOtHolidayNonWorking: 'Holiday Non-\nWorking',

    febOtWorkDay: 'Working\nDay',
    febOtHolidayWork: 'Holiday\nWorking',
    febOtHolidayNonWorking: 'Holiday Non-\nWorking',

    marOtWorkDay: 'Working\nDay',
    marOtHolidayWork: 'Holiday\nWorking',
    marOtHolidayNonWorking: 'Holiday Non-\nWorking',

    aprOtWorkDay: 'Working\nDay',
    aprOtHolidayWork: 'Holiday\nWorking',
    aprOtHolidayNonWorking: 'Holiday Non-\nWorking',

    mayOtWorkDay: 'Working\nDay',
    mayOtHolidayWork: 'Holiday\nWorking',
    mayOtHolidayNonWorking: 'Holiday Non-\nWorking',

    junOtWorkDay: 'Working\nDay',
    junOtHolidayWork: 'Holiday\nWorking',
    junOtHolidayNonWorking: 'Holiday Non-\nWorking',

    julOtWorkDay: 'Working\nDay',
    julOtHolidayWork: 'Holiday\nWorking',
    julOtHolidayNonWorking: 'Holiday Non-\nWorking',

    augOtWorkDay: 'Working\nDay',
    augOtHolidayWork: 'Holiday\nWorking',
    augOtHolidayNonWorking: 'Holiday Non-\nWorking',

    sepOtWorkDay: 'Working\nDay',
    sepOtHolidayWork: 'Holiday\nWorking',
    sepOtHolidayNonWorking: 'Holiday Non-\nWorking',

    octOtWorkDay: 'Working\nDay',
    octOtHolidayWork: 'Holiday\nWorking',
    octOtHolidayNonWorking: 'Holiday Non-\nWorking',

    novOtWorkDay: 'Working\nDay',
    novOtHolidayWork: 'Holiday\nWorking',
    novOtHolidayNonWorking: 'Holiday Non-\nWorking',

    decOtWorkDay: 'Working\nDay',
    decOtHolidayWork: 'Holiday\nWorking',
    decOtHolidayNonWorking: 'Holiday Non-\nWorking',
  });

  ws.getRow(4).height = 37.5;

  for (let col = 7; col < 43; col++) {
    const cell = ws.getRow(4).getCell(col);
    cell.font = {
      color: { argb: 'FFFFFFFF' },
      name: 'Arial',
      size: 9,
      bold: true,
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B050' },
    };
  }

  for (let col = 2; col <= 6; col++) {
    ws.mergeCells(3, col, 4, col);
    const cell = ws.getRow(3).getCell(col);
    cell.font = {
      color: { argb: 'FFFFFFFF' },
      name: 'Arial',
      size: 9,
      bold: true,
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B050' },
    };
  }

  data.users = data.users.sort(function (a, b) {
    var keyA = a.id,
      keyB = b.id;
    if (keyA > keyB) return 1;
    if (keyA < keyB) return -1;
    return 0;
  });

  data.users.forEach((user) => {
    user.projectSummary.forEach((project) => {
      if (project.projectNo !== 'Leave') {
        let workJson = {
          janOtWorkDay: 0,
          janOtHolidayWork: 0,
          janOtHolidayNonWorking: 0,
          febOtWorkDay: 0,
          febOtHolidayWork: 0,
          febOtHolidayNonWorking: 0,
          marOtWorkDay: 0,
          marOtHolidayWork: 0,
          marOtHolidayNonWorking: 0,
          aprOtWorkDay: 0,
          aprOtHolidayWork: 0,
          aprOtHolidayNonWorking: 0,
          mayOtWorkDay: 0,
          mayOtHolidayWork: 0,
          mayOtHolidayNonWorking: 0,
          junOtWorkDay: 0,
          junOtHolidayWork: 0,
          junOtHolidayNonWorking: 0,
          julOtWorkDay: 0,
          julOtHolidayWork: 0,
          julOtHolidayNonWorking: 0,
          augOtWorkDay: 0,
          augOtHolidayWork: 0,
          augOtHolidayNonWorking: 0,
          sepOtWorkDay: 0,
          sepOtHolidayWork: 0,
          sepOtHolidayNonWorking: 0,
          octOtWorkDay: 0,
          octOtHolidayWork: 0,
          octOtHolidayNonWorking: 0,
          novOtWorkDay: 0,
          novOtHolidayWork: 0,
          novOtHolidayNonWorking: 0,
          decOtWorkDay: 0,
          decOtHolidayWork: 0,
          decOtHolidayNonWorking: 0,
        };
        project.detailJson.forEach((detail) => {
          switch (detail.month) {
            case 1:
              workJson.janOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.janOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.janOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 2:
              workJson.febOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.febOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.febOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 3:
              workJson.marOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.marOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.marOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 4:
              workJson.aprOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.aprOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.aprOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 5:
              workJson.mayOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.mayOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.mayOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 6:
              workJson.junOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.junOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.junOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 7:
              workJson.julOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.julOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.julOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 8:
              workJson.augOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.augOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.augOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 9:
              workJson.sepOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.sepOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.sepOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 10:
              workJson.octOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.octOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.octOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 11:
              workJson.novOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.novOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.novOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            case 12:
              workJson.decOtWorkDay = detail.otWorkingMinutes / 60 / 8;
              workJson.decOtHolidayWork =
                detail.otHolidayWorkingMinutes / 60 / 8;
              workJson.decOtHolidayNonWorking =
                detail.otHolidayNonWorkingMinutes / 60 / 8;
              break;
            default:
              break;
          }
        });

        ws.addRow({
          empCode: user.empCode,
          userName: user.firstnameEn + ' ' + user.lastnameEn,
          departmentName: user.departmentName,
          project: project.projectNo,
          projectName: project.projectName,
          ...workJson,
        });
      }
    });
  });

  const totalHours = {
    janOtWorkDay: { formula: `=SUM(G5:G${ws.rowCount})` },
    janOtHolidayWork: { formula: `=SUM(H5:H${ws.rowCount})` },
    janOtHolidayNonWorking: { formula: `=SUM(I5:I${ws.rowCount})` },
    febOtWorkDay: { formula: `=SUM(J5:J${ws.rowCount})` },
    febOtHolidayWork: { formula: `=SUM(K5:K${ws.rowCount})` },
    febOtHolidayNonWorking: { formula: `=SUM(L5:L${ws.rowCount})` },
    marOtWorkDay: { formula: `=SUM(M5:M${ws.rowCount})` },
    marOtHolidayWork: { formula: `=SUM(N5:N${ws.rowCount})` },
    marOtHolidayNonWorking: { formula: `=SUM(O5:O${ws.rowCount})` },
    aprOtWorkDay: { formula: `=SUM(P5:P${ws.rowCount})` },
    aprOtHolidayWork: { formula: `=SUM(Q5:Q${ws.rowCount})` },
    aprOtHolidayNonWorking: { formula: `=SUM(R5:R${ws.rowCount})` },
    mayOtWorkDay: { formula: `=SUM(S5:S${ws.rowCount})` },
    mayOtHolidayWork: { formula: `=SUM(T5:T${ws.rowCount})` },
    mayOtHolidayNonWorking: { formula: `=SUM(U5:U${ws.rowCount})` },
    junOtWorkDay: { formula: `=SUM(V5:V${ws.rowCount})` },
    junOtHolidayWork: { formula: `=SUM(W5:W${ws.rowCount})` },
    junOtHolidayNonWorking: { formula: `=SUM(X5:X${ws.rowCount})` },
    julOtWorkDay: { formula: `=SUM(Y5:Y${ws.rowCount})` },
    julOtHolidayWork: { formula: `=SUM(Z5:Z${ws.rowCount})` },
    julOtHolidayNonWorking: { formula: `=SUM(AA5:AA${ws.rowCount})` },
    augOtWorkDay: { formula: `=SUM(AB5:AB${ws.rowCount})` },
    augOtHolidayWork: { formula: `=SUM(AC5:AC${ws.rowCount})` },
    augOtHolidayNonWorking: { formula: `=SUM(AD5:AD${ws.rowCount})` },
    sepOtWorkDay: { formula: `=SUM(AE5:AE${ws.rowCount})` },
    sepOtHolidayWork: { formula: `=SUM(AF5:AF${ws.rowCount})` },
    sepOtHolidayNonWorking: { formula: `=SUM(AG5:AG${ws.rowCount})` },
    octOtWorkDay: { formula: `=SUM(AH5:AH${ws.rowCount})` },
    octOtHolidayWork: { formula: `=SUM(AI5:AI${ws.rowCount})` },
    octOtHolidayNonWorking: { formula: `=SUM(AJ5:AJ${ws.rowCount})` },
    novOtWorkDay: { formula: `=SUM(AK5:AK${ws.rowCount})` },
    novOtHolidayWork: { formula: `=SUM(AL5:AL${ws.rowCount})` },
    novOtHolidayNonWorking: { formula: `=SUM(AM5:AM${ws.rowCount})` },
    decOtWorkDay: { formula: `=SUM(AN5:AN${ws.rowCount})` },
    decOtHolidayWork: { formula: `=SUM(AO5:AO${ws.rowCount})` },
    decOtHolidayNonWorking: { formula: `=SUM(AP5:AP${ws.rowCount})` },
  };

  ws.addRow({ ...totalHours });
  ws.mergeCells(ws.rowCount, 2, ws.rowCount, 6);
  ws.lastRow.getCell(2).value = 'summary';

  ws.getCell('G2').border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  for (let row = 3; row <= ws.rowCount; row++) {
    for (let col = 2; col <= 42; col++) {
      ws.getRow(row).getCell(col).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  }

  for (let row = 5; row <= ws.rowCount; row++) {
    ws.getRow(row).getCell(2).alignment = { horizontal: 'center' };
    for (let col = 3; col <= 6; col++) {
      if (row !== ws.rowCount) {
        ws.getRow(row).getCell(col).alignment = {
          horizontal: 'left',
          wrapText: true,
        };
      }
    }
    for (let col = 7; col <= 42; col++) {
      ws.getRow(row).getCell(col).alignment = { horizontal: 'right' };
      ws.getRow(row).getCell(col).numFmt = '0.00';
    }
  }

  const filename = `Summary_Timesheet_OT_${state.year}.xlsx`;

  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};

export const generateExcelSummaryByProject = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('My Sheet', {
    views: [{ state: 'frozen', ySplit: 3 }],
  });

  ws.columns = [
    { width: 9.71 },
    { key: 'project', width: 11.57 },
    { key: 'projectName', width: 15.87 },
    { key: 'empCode', width: 11.57 },
    { key: 'userName', width: 62.14 },
    { key: 'projectRole', width: 15.87 },
    { key: 'jan', width: 8.43 },
    { key: 'feb', width: 8.43 },
    { key: 'mar', width: 8.43 },
    { key: 'apr', width: 8.43 },
    { key: 'may', width: 8.43 },
    { key: 'jun', width: 8.43 },
    { key: 'jul', width: 8.43 },
    { key: 'aug', width: 8.43 },
    { key: 'sep', width: 8.43 },
    { key: 'oct', width: 8.43 },
    { key: 'nov', width: 8.43 },
    { key: 'dec', width: 8.43 },
  ];

  ws.mergeCells('G2:R2');
  ws.getCell('G2').value = 'Effort (MD)';
  ws.getCell('G2').font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 9,
    bold: true,
  };
  ws.getCell('G2').alignment = { vertical: 'middle', horizontal: 'center' };
  ws.getCell('G2').fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF538DD5' },
  };
  ws.properties.defaultRowHeight = 15;

  ws.addRow({
    jan: 'Jan-' + state.year,
    feb: 'Feb-' + state.year,
    mar: 'Mar-' + state.year,
    apr: 'Apr-' + state.year,
    may: 'May-' + state.year,
    jun: 'Jun-' + state.year,
    jul: 'Jul-' + state.year,
    aug: 'Aug-' + state.year,
    sep: 'Sep-' + state.year,
    oct: 'Oct-' + state.year,
    nov: 'Nov-' + state.year,
    dec: 'Dec-' + state.year,
  });

  ws.mergeCells('B2:B3');
  ws.getCell('B2').value = 'Project';
  ws.mergeCells('C2:C3');
  ws.getCell('C2').value = 'Project Name';
  ws.mergeCells('D2:D3');
  ws.getCell('D2').value = 'ID';
  ws.mergeCells('E2:E3');
  ws.getCell('E2').value = 'Name-Surname';
  ws.mergeCells('F2:F3');
  ws.getCell('F2').value = 'Project Role';

  const row3 = ws.getRow(3);
  row3.height = 48;
  row3.font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 9,
    bold: true,
  };
  row3.alignment = { vertical: 'middle', horizontal: 'center' };
  for (let i = 2; i <= 18; i++) {
    row3.getCell(i).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF538DD5' },
    };
  }

  data = data.sort(function (a, b) {
    const keyA = a.projectNo,
      keyB = b.projectNo;
    if (keyA > keyB) return 1;
    if (keyA < keyB) return -1;
    return 0;
  });

  const monthColumn = {
    jan: 'G',
    feb: 'H',
    mar: 'I',
    apr: 'J',
    may: 'K',
    jun: 'L',
    jul: 'M',
    aug: 'N',
    sep: 'O',
    oct: 'P',
    nov: 'Q',
    dec: 'R',
  };

  const totalHours = {
    jan: '=SUM(',
    feb: '=SUM(',
    mar: '=SUM(',
    apr: '=SUM(',
    may: '=SUM(',
    jun: '=SUM(',
    jul: '=SUM(',
    aug: '=SUM(',
    sep: '=SUM(',
    oct: '=SUM(',
    nov: '=SUM(',
    dec: '=SUM(',
  };

  data.forEach((project) => {
    let idx = ws.rowCount + 1;
    project.userSummary.forEach((user) => {
      const manHour = {
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
      };
      user.detailJson.forEach((detail) => {
        switch (detail.month) {
          case 1:
            manHour.jan = detail.totalMinutes / 60 / 8;
            break;
          case 2:
            manHour.feb = detail.totalMinutes / 60 / 8;
            break;
          case 3:
            manHour.mar = detail.totalMinutes / 60 / 8;
            break;
          case 4:
            manHour.apr = detail.totalMinutes / 60 / 8;
            break;
          case 5:
            manHour.may = detail.totalMinutes / 60 / 8;
            break;
          case 6:
            manHour.jun = detail.totalMinutes / 60 / 8;
            break;
          case 7:
            manHour.jul = detail.totalMinutes / 60 / 8;
            break;
          case 8:
            manHour.aug = detail.totalMinutes / 60 / 8;
            break;
          case 9:
            manHour.sep = detail.totalMinutes / 60 / 8;
            break;
          case 10:
            manHour.oct = detail.totalMinutes / 60 / 8;
            break;
          case 11:
            manHour.nov = detail.totalMinutes / 60 / 8;
            break;
          case 12:
            manHour.dec = detail.totalMinutes / 60 / 8;
            break;
          default:
            break;
        }
      });

      ws.addRow({
        empCode: user.empCode,
        userName: user.firstnameEn + ' ' + user.lastnameEn,
        projectRole: user.projectRole,
        ...manHour,
      });
    });
    ws.insertRow(idx, {
      project: project.projectNo,
      projectName: project.projectName,
    });
    ws.mergeCells(idx, 3, idx, 6);
    Object.entries(monthColumn).forEach(([key, value]) => {
      const formula = `=SUM(${value}${idx + 1}:${value}${ws.rowCount})`;
      ws.getRow(idx).getCell(key).value = { formula: formula };
      ws.getRow(idx).getCell(key).font = {
        bold: true,
      };
      totalHours[key] = `${totalHours[key]}${value}${idx},`;
    });
    ws.addRow({});
  });
  ws.addRow({});
  Object.keys(totalHours).forEach((key) => {
    totalHours[key] = `${totalHours[key]})`;
    ws.lastRow.getCell(key).value = {
      formula: totalHours[key],
    };
  });
  ws.mergeCells(ws.rowCount, 2, ws.rowCount, 6);
  ws.lastRow.getCell(2).value = 'Total';
  ws.lastRow.getCell(2).alignment = { horizontal: 'center' };
  ws.lastRow.font = {
    bold: true,
  };

  for (let i = 2; i <= ws.rowCount; i++) {
    for (let j = 2; j <= 18; j++) {
      ws.getRow(i).getCell(j).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  }

  for (let i = 4; i <= ws.rowCount; i++) {
    if (!ws.getRow(i).getCell(4).isMerged) {
      ws.getRow(i).getCell(4).alignment = { horizontal: 'center' };
    }
    for (let j = 7; j <= 18; j++) {
      ws.getRow(i).getCell(j).alignment = { horizontal: 'right' };
      ws.getRow(i).getCell(j).numFmt = '0.00';
    }
  }

  const filename = `Summary_Timesheet_${state.year}_By_Project.xlsx`;

  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};

export const generateExcelMedicalClaim = (data, state) => {
  const wb = new Excel.Workbook();
  const ws = wb.addWorksheet('My Sheet', {
    views: [{ state: 'frozen', ySplit: 3 }],
  });

  ws.columns = [
    { key: 'no', width: 16.57 },
    { key: 'requestDate', width: 16.57 },
    { key: 'effectiveDate', width: 16.57 },
    { key: 'approveDate', width: 16.57 },
    { key: 'empCode', width: 16.57 },
    { key: 'name', width: 30.57 },
    { key: 'type', width: 32.57 },
    { key: 'amount', width: 16.57 },
    { key: 'boi', width: 16.57 },
    { key: 'position', width: 24.57 },
    { key: 'department', width: 24.57 },
    { key: 'status', width: 24.57 },
    { key: 'cancelDate', width: 16.57 },
  ];

  ws.properties.defaultRowHeight = 20;

  const row2 = ws.getRow(2);
  row2.font = {
    name: 'Arial',
    size: 11,
  };
  row2.getCell(1).value = 'Year';
  row2.getCell(2).value = state.year;
  row2.getCell(7).value = 'As of';
  ws.mergeCells(2, 8, 2, 9);
  row2.getCell(8).value = moment().format('DD/MM/YYYY:HH:MM');

  ws.addRow({
    no: 'No.',
    requestDate: 'Request Date',
    effectiveDate: 'Effective Date',
    approveDate: 'Approve Date',
    empCode: 'Emp ID',
    name: 'Name-Surname',
    type: 'Type',
    amount: 'Amount',
    boi: 'Flag',
    position: 'Position',
    department: 'Department',
    status: 'Status',
    cancelDate: 'Cancel Date',
  });

  const row3 = ws.getRow(3);
  row3.font = {
    color: { argb: 'FFFFFFFF' },
    name: 'Arial',
    size: 11,
    bold: true,
  };
  row3.alignment = { vertical: 'middle', horizontal: 'center' };
  for (let i = 1; i <= 13; i++) {
    row3.getCell(i).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00B0F0' },
    };
  }

  data.forEach((record) => {
    ws.addRow({
      no: record.runningNumber,
      requestDate: moment(record.createDatetime).format('DD-MMM-YYYY'),
      effectiveDate: moment(record.effectiveDate).format('DD-MMM-YYYY'),
      approveDate:
        record.requestStatusName === 'Approved'
          ? moment(record.updateDatetime).format('DD-MMM-YYYY')
          : '-',
      empCode: record.userInfo.employeeId,
      name: record.userInfo.firstnameEn + ' ' + record.userInfo.lastnameEn,
      type: record.medicalClaimName,
      amount: record.amountUse,
      boi: record.userInfo.isBoi ? 'B' : 'N',
      position: record.userInfo.position,
      department: record.userInfo.position,
      status: record.requestStatusName,
      cancelDate: record.requestStatusName.includes('Canceled')
        ? moment(record.updateDatetime).format('DD-MMM-YYYY')
        : '-',
    });
  });

  for (let row = 1; row <= ws.rowCount; row++) {
    for (let col = 1; col <= 13; col++) {
      ws.getRow(row).getCell(col).border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    }
  }

  for (let row = 4; row <= ws.rowCount; row++) {
    for (let col = 1; col <= 5; col++) {
      ws.getRow(row).getCell(col).alignment = { horizontal: 'center' };
    }
    ws.getRow(row).getCell(9).alignment = { horizontal: 'center' };
    ws.getRow(row).getCell(13).alignment = { horizontal: 'center' };
    ws.getRow(row).getCell(8).numFmt = '0.00';
  }

  const filename = `Medical_Claim_Summary_${state.year}.xlsx`;

  wb.xlsx
    .writeBuffer({
      base64: true,
    })
    .then(function (xls64) {
      var a = document.createElement('a');
      var data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = URL.createObjectURL(data);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    })
    .catch(function (error) {
      console.log(error.message);
    });
};
